import axios from "./axios";

export default {
    list(params = {}) {
        return axios({ method: 'GET', url: '/accountingtotalsrecord/list', params });
    },
    generate(data) {
        return axios({ method: 'POST', url: '/accountingtotalsrecord/generate', data });
    },
    confirm(id) {
        return axios({ method: 'PATCH', url: `/accountingtotalsrecord/${id}/confirm` });
    },
    updatePayment(id, data) {
        return axios({ method: 'PATCH', url: `/accountingtotalsrecord/${id}/payment`, data });
    },
    remove(id) {
        return axios({ method: 'DELETE', url: `/accountingtotalsrecord/${id}` });
    },
};
